<template>
  <Nav></Nav>
  <main class="new-template">
    <back-button></back-button>
    <TemplateEditor :edit="false" :orgSlug="orgSlug" :prjSlug="prjSlug"></TemplateEditor>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackButton from '@/components/BackButton.vue';
import Nav from '@/components/Nav.vue';
import TemplateEditor from '@/components/TemplateEditor.vue';

export default defineComponent({
  name: 'NewTemplate',
  components: {
    BackButton,
    Nav,
    TemplateEditor,
  },
  data() {
    return {
      prjSlug: this.$route.params.prj_slug as string,
      orgSlug: this.$route.params.org_slug as string,
    };
  },
});
</script>